import store from "@/store";
import { db } from "@/main";
import auth from "@/store/modules/auth";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import { ActionContext } from "vuex";
import { FirestoreActionContext, FirestoreAction } from "./vuexFirestoreHelper";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import { TripEntity } from "@/api/types";

interface TripsState {
  trips: any[];
}

@Module({
  namespaced: true,
  name: "trips",
  dynamic: true,
  store
})
export default class TripsModule extends VuexModule implements TripsState {
  trips: any[] = [];

  @Action
  @FirestoreAction()
  bindTrips() {
    if (auth.user) {
      const { bindFirestoreRef } = this.context as FirestoreActionContext<
        TripsState,
        any
      >;
      const userId = auth.user.uid;
      return bindFirestoreRef(
        "trips",
        db.collection("trips").where("user", "==", userId)
      );
    }
  }

  @Action
  saveTrip(trip: TripEntity) {
    db.collection("trips").add(trip);
  }

  @Action
  deleteTrip(trip: any) {
    db.collection("trips")
      .doc(trip.id)
      .delete();
  }
}